import {
  GET_ORDER_INVOICE,
  GET_ORDER_INVOICE_OK,
  GET_ORDER_INVOICE_ERR,
  DO_ORDER_INVOICE_CLEANUP,
} from './actionTypes';

/********* SINGLE *********/

export const getOrderInvoice = id => ({
  type: GET_ORDER_INVOICE,
  payload: { id }
});

export const getOrderInvoiceOk = response => ({
  type: GET_ORDER_INVOICE_OK,
  payload: { response },
});

export const getOrderInvoiceErr = error => ({
  type: GET_ORDER_INVOICE_ERR,
  payload: { error },
});

export const doOrderInvoiceCleanup = () => ({
  type: DO_ORDER_INVOICE_CLEANUP,
});